<template>
    <div class="qrcode-container">
        <canvas ref="qrcodeCanvas"></canvas>
        <br>
    </div>
    <div class="qrcode-container" v-if="showUrlBeneath">
        <a id="audienceAppURL" :href="audienceUrl" target="_blank" rel="noopener noreferrer">
            {{ audienceUrl }}
        </a>
    </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
    name: 'QRCode',
    props: {
        audienceUrl: {
            type: String,
            required: true,
        },
        qrCodeSize: {
            type: Number,
            default: 256,
        },
        showUrlBeneath: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        this.generateQRCode();
    },
    methods: {
        generateQRCode() {
            QRCode.toCanvas(this.$refs.qrcodeCanvas, this.audienceUrl, { width: this.qrCodeSize }, (error) => {
                if (error) {
                    console.error('Error generating QR code:', error);
                }
            });
        },
    },
};
</script>

<style scoped>
.qrcode-container {
    /* display: flex; */
    justify-content: center;
    align-items: center;
}
</style>
